module.exports = __webpack_public_path__ + "media/images/heart--empty-0d40326106b6fdc00fe4e0f5b487c596.svg";